// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"layout_mainContainer__1IdeY","contentWrapper":"layout_contentWrapper__1eAw7","mainContent":"layout_mainContent__1mJg3"};